import type { EinkommenssicherungType } from '@/api/einkommenssicherung/types';
import { useGet, usePost } from "@/api/lib/integration";

export const getEvaluation = useGet<{ fragen: Record<string, unknown> }, EinkommenssicherungType>('/api/einkommenssicherung/auswerten');
export const storeQuiz = usePost<{ fragen: Record<string, unknown> }, void>('/api/einkommenssicherung');
